<template>
  <FormCadastro
    :title="
      'Informações do emitente ' + (emitente.ID_EMITENTE ? '- ' + emitente.ID_EMITENTE : '')
    "
    :loading="loading"
    @voltar="voltar"
    @salvar="salvar"
    :exibirBotoes="exibirBotoes"
    :dataInclusao="emitente.DATA_INCLUSAO"
    :usuarioInclusao="emitente.USUARIO_INCLUSAO"
    :dataAlteracao="emitente.DATA_ALTERACAO"
    :usuarioAlteracao="emitente.USUARIO"
    :botoesMenu="botoesMenu"
    @botoesMenu="clickMenu"
  >
    <h3 class="font-size-lg text-dark font-weight-bold mb-6 titulo-collapse" :class="{'titulo-collapse-fechado': !exibirDadosPrincipais}" @click="exibirDadosPrincipais = !exibirDadosPrincipais">
      Dados Principais: <img class="image-collapse" src="media/icons/arrow-down.png" :class="{'image-collapse-rotate': exibirDadosPrincipais}" />
    </h3>
    <b-collapse class="conteudo-collapse" :visible="exibirDadosPrincipais">
      <div class="row">
        <div class="col-md-4">
          <b-form-group label="Pessoa">
            <b-form-radio v-model="emitente.PESSOA" name="pessoa" value="F" :disabled="emitente.CGC_CPF_STATUS_RECEITA == '1'">
              Física
            </b-form-radio>
            <b-form-radio v-model="emitente.PESSOA" name="pessoa" value="J" :disabled="emitente.CGC_CPF_STATUS_RECEITA == '1'">
              Jurídica
            </b-form-radio>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <InputCPF 
            ref="cpf" 
            v-if="emitente.PESSOA == 'F'" 
            v-model="emitente.CGC_CPF" 
            :disabled="emitente.CGC_CPF_STATUS_RECEITA == '1'" 
            :datanascimento="emitente.DATA_NASCIMENTO" 
            :validadoreceita="emitente.CGC_CPF_STATUS_RECEITA" 
            @validacaoReceitaCPF="validacaoReceitaCPF" 
          />
          <InputCNPJ 
            ref="cnpj" 
            v-if="emitente.PESSOA == 'J'" 
            v-model="emitente.CGC_CPF" 
            :disabled="emitente.CGC_CPF_STATUS_RECEITA == '1'" 
            :validadoreceita="emitente.CGC_CPF_STATUS_RECEITA" 
            @validacaoReceitaCNPJ="validacaoReceitaCNPJ" 
          />
        </div>
        <div class="col-md-4">
          <b-form-group
            :label="emitente.PESSOA == 'F' ? 'Data Nascimento:' : 'Data Abertura:'"
          >
            <b-form-input
              type="date"
              v-model="emitente.DATA_NASCIMENTO"
              :placeholder="emitente.PESSOA == 'F' ? 'Data Nascimento:' : 'Data Abertura:'"
              :disabled="((emitente.CGC_CPF_STATUS_RECEITA == '1') && (emitente.PESSOA == 'F'))" 
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2" v-if="emitente.PESSOA == 'F'">
          <b-form-group label="Tratamento:">
            <b-form-select
              v-model="emitente.TRATAMENTO"
              :options="tratamentos"
            ></b-form-select>
          </b-form-group>
        </div>
        <div :class="{ 'col-md-8': emitente.PESSOA == 'F', 'col-md-12': emitente.PESSOA == 'J' }">
          <b-form-group :label="emitente.PESSOA == 'F' ? 'Nome:' : 'Razão Social:'">
            <b-form-input
              type="text"
              v-model="emitente.RAZAO_SOCIAL"
              :placeholder="emitente.PESSOA == 'F' ? 'Nome:' : 'Razão Social:'"
              :disabled="emitente.CGC_CPF_STATUS_RECEITA == '1'" 
              @blur="preencheFantasiaResumido"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2" v-if="emitente.PESSOA == 'F'">
          <b-form-group label="Sexo:">
            <b-form-select
              v-model="emitente.SEXO"
              :options="sexos"
            ></b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Nome Fantasia:">
            <b-form-input
              type="text"
              v-model="emitente.NOME_FANTASIA"
              placeholder="Nome Fantasia"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Nome Resumido:">
            <b-form-input
              type="text"
              v-model="emitente.NOME_RESUMIDO"
              placeholder="Nome Resumido"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <SearchBoxCategoriaEmitente
            ref="categoriaEmitente"
            v-model="emitente.ID_EMITENTE_CATEGORIA"
          />
        </div>
      </div>
    </b-collapse>
    <div class="separator separator-dashed my-5"></div>
    <h3 class="font-size-lg text-dark font-weight-bold mb-6 titulo-collapse" :class="{'titulo-collapse-fechado': !exibirEnderecos}" @click="exibirEnderecos = !exibirEnderecos">
      Endereços: <img class="image-collapse" src="media/icons/arrow-down.png" :class="{'image-collapse-rotate': exibirEnderecos}" />
    </h3>
    <b-collapse class="conteudo-collapse" :visible="exibirEnderecos">
      <b-tabs content-class="mt-3" justified>
        <b-tab title="Endereço Principal" style="margin-left: 1px solid #000;" active>
          <div class="row">
            <div class="col-md-12">
              <b-form-group label="Tipo">
                <b-form-radio v-model="emitente.TIPO_ENDERECO" name="tipoendereco" value="R" inline>
                  Residencial
                </b-form-radio>
                <b-form-radio v-model="emitente.TIPO_ENDERECO" name="tipoendereco" value="C" inline>
                  Comercial
                </b-form-radio>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <InputCEP ref="cep" v-model="emitente.CEP" @buscacep="buscaCEP" />
            </div>
            <div class="col-md-2">
              <InputLogradouroTipo v-model="emitente.LOGRADOURO_TIPO" />
            </div>
            <div class="col-md-6">
              <b-form-group label="Logradouro:">
                <b-form-input
                  type="text"
                  v-model="emitente.LOGRADOURO_NOME"
                  placeholder="Logradouro"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group label="Número:">
                <b-form-input
                  type="number"
                  v-model="emitente.LOGRADOURO_NUMERO"
                  placeholder="Número"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Complemento:">
                <b-form-input
                  type="text"
                  v-model="emitente.LOGRADOURO_COMPLEMENTO"
                  placeholder="Complemento"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Bairro:">
                <b-form-input
                  type="text"
                  v-model="emitente.BAIRRO"
                  placeholder="Bairro"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <InputEstado v-model="emitente.ESTADO" @buscacidades="buscaCidades" />
            </div>
            <div class="col-md-3">
              <InputCidade
                v-model="emitente.CIDADE"
                :cidades="cidades"
                @change="selecionouCidade"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <b-form-group label="País:">
                <b-form-input
                  type="text"
                  v-model="emitente.PAIS"
                  placeholder="País"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Localidade:">
                <b-form-input
                  type="text"
                  v-model="emitente.LOCALIDADE"
                  placeholder="Localidade"
                  disabled
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="IBGE:">
                <b-form-input
                  type="number"
                  v-model="emitente.COD_IBGE"
                  placeholder="IBGE"
                  disabled
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
        </b-tab>
        <b-tab title="Endereço Secundário">
          <div class="row">
            <div class="col-md-6">
              <b-form-group label="Tipo">
                <b-form-radio v-model="emitente.TIPO_END_COBR" name="tipoenderecocobranca" value="R" inline>
                  Residencial
                </b-form-radio>
                <b-form-radio v-model="emitente.TIPO_END_COBR" name="tipoenderecocobranca" value="C" inline>
                  Comercial
                </b-form-radio>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="Utiliza DDA">
                <b-form-radio v-model="emitente.USA_DDA" name="usa_dda" value="0" inline>
                  Não
                </b-form-radio>
                <b-form-radio v-model="emitente.USA_DDA" name="usa_dda" value="1" inline>
                  Sim
                </b-form-radio>
                <b-form-radio v-model="emitente.USA_DDA" name="usa_dda" value="2" inline>
                  Cliente definirá
                </b-form-radio>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <InputCEP ref="cobrcep" v-model="emitente.COBR_CEP" @buscacep="buscaCEPCobr" />
            </div>
            <div class="col-md-2">
              <InputLogradouroTipo v-model="emitente.COBR_LOGRADOURO_TIPO" />
            </div>
            <div class="col-md-6">
              <b-form-group label="Logradouro:">
                <b-form-input
                  type="text"
                  v-model="emitente.COBR_LOGRADOURO"
                  placeholder="Logradouro"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group label="Número:">
                <b-form-input
                  type="number"
                  v-model="emitente.COBR_LOGRADOURO_NUMERO"
                  placeholder="Número"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Complemento:">
                <b-form-input
                  type="text"
                  v-model="emitente.COBR_LOGRADOURO_COMPLEMENTO"
                  placeholder="Complemento"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Bairro:">
                <b-form-input
                  type="text"
                  v-model="emitente.COBR_BAIRRO"
                  placeholder="Bairro"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <InputEstado v-model="emitente.COBR_ESTADO" @buscacidades="buscaCidadesCobr" />
            </div>
            <div class="col-md-3">
              <InputCidade
                v-model="emitente.COBR_CIDADE"
                :cidades="cidadesCobr"
              />
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-collapse>
    <div class="separator separator-dashed my-5"></div>
    <EmitenteTelefones ref="telefones" :telefonesEmitente="telefones" />
    <div class="separator separator-dashed my-5"></div>
    <h3 class="font-size-lg text-dark font-weight-bold mb-6 titulo-collapse" :class="{'titulo-collapse-fechado': !exibirInformacoesAdicionais}" @click="exibirInformacoesAdicionais = !exibirInformacoesAdicionais">
      Informações Adicionais: <img class="image-collapse" src="media/icons/arrow-down.png" :class="{'image-collapse-rotate': exibirInformacoesAdicionais}" />
    </h3>
    <b-collapse class="conteudo-collapse" :visible="exibirInformacoesAdicionais">
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Observações:">
            <b-form-textarea
              v-model="emitente.OBSERVACAO"
              placeholder="Observações"
              rows="8"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Observações de Atendimento:">
            <b-form-textarea
              v-model="emitente.OBSERVACAO_ATENDIMENTO"
              placeholder="Observações de Atendimento"
              rows="8"
            ></b-form-textarea>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Naturalidade:">
            <b-form-input
              type="text"
              v-model="emitente.NATURALIDADE"
              placeholder="Naturalidade"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Formatura:">
            <b-form-input
              type="date"
              v-model="emitente.DATA_FORMATURA"
              placeholder="Formatura"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Nº Registro:">
            <b-form-input
              type="text"
              v-model="emitente.CONSELHO_NUMERO"
              placeholder="Nº Registro"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <SearchBoxProfissao
            ref="profissao"
            v-model="emitente.ID_PROFISSAO"
          />
        </div>
      </div>
    </b-collapse>
    <div class="separator separator-dashed my-5"></div>
    <h3 class="font-size-lg text-dark font-weight-bold mb-6 titulo-collapse" :class="{'titulo-collapse-fechado': !exibirCamposConfiguraveis}" @click="exibirCamposConfiguraveis = !exibirCamposConfiguraveis">
      Campos Configuráveis: <img class="image-collapse" src="media/icons/arrow-down.png" :class="{'image-collapse-rotate': exibirCamposConfiguraveis}" />
    </h3>
    <b-collapse class="conteudo-collapse" :visible="exibirCamposConfiguraveis">
      <div class="row">
        <div class="col-md-6">
          <b-form-group :label="((campo1Nome) ? campo1Nome : 'Campo1')">
            <b-form-input
              type="text"
              v-model="emitente.CAMPO1"
              :placeholder="(campo1Nome) ? campo1Nome : 'Campo1'"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group :label="(campoCombo1Nome) ? campoCombo1Nome : 'Campo Combo1'">
            <b-form-select
              v-model="emitente.CAMPO_COMBO_1"
              :options="campoCombo1opcoes"
            ></b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group :label="((campo2Nome) ? campo2Nome : 'Campo2')">
            <b-form-input
              type="text"
              v-model="emitente.CAMPO2"
              :placeholder="(campo2Nome) ? campo2Nome : 'Campo2'"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group :label="(campoCombo2Nome) ? campoCombo2Nome : 'Campo Combo2'">
            <b-form-select
              v-model="emitente.CAMPO_COMBO_2"
              :options="campoCombo2opcoes"
            ></b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group :label="((campo3Nome) ? campo3Nome : 'Campo3')">
            <b-form-input
              type="text"
              v-model="emitente.CAMPO3"
              :placeholder="(campo3Nome) ? campo3Nome : 'Campo3'"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group :label="(campoCombo3Nome) ? campoCombo3Nome : 'Campo Combo3'">
            <b-form-select
              v-model="emitente.CAMPO_COMBO_3"
              :options="campoCombo3opcoes"
            ></b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group :label="((campo4Nome) ? campo4Nome : 'Campo4')" style="margin-bottom: 0px;">
            <b-form-input
              type="text"
              v-model="emitente.CAMPO4"
              :placeholder="(campo4Nome) ? campo4Nome : 'Campo4'"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group :label="(campoCombo4Nome) ? campoCombo4Nome : 'Campo Combo4'" style="margin-bottom: 0px;">
            <b-form-select
              v-model="emitente.CAMPO_COMBO_4"
              :options="campoCombo4opcoes"
            ></b-form-select>
          </b-form-group>
        </div>
      </div>
    </b-collapse>
    <div class="separator separator-dashed my-5"></div>
    <h3 class="font-size-lg text-dark font-weight-bold mb-6 titulo-collapse" :class="{'titulo-collapse-fechado': !exibirRegistros}" @click="exibirRegistros = !exibirRegistros">
      Registros: <img class="image-collapse" src="media/icons/arrow-down.png" :class="{'image-collapse-rotate': exibirRegistros}" />
    </h3>
    <b-collapse class="conteudo-collapse" :visible="exibirRegistros">
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Data Admissão:">
            <b-form-input
              type="date"
              v-model="emitente.DATA_ADMISSAO"
              placeholder="Data Admissão"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Registro:">
            <b-form-input
              type="text"
              v-model="emitente.REGISTRO"
              placeholder="Registro"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <b-form-group label="RG:">
            <b-form-input
              type="text"
              v-model="emitente.INSCRICAOESTADUAL_RG"
              placeholder="RG"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Orgão Expedidor:">
            <b-form-input
              type="text"
              v-model="emitente.ORGAO_EXPEDIDOR"
              placeholder="Orgão Expedidor"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Data Emissão:">
            <b-form-input
              type="date"
              v-model="emitente.DATA_EMISSAO_RG"
              placeholder="Data Emissão"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Distância em Horas:">
            <b-form-input
              type="time"
              v-model="emitente.DISTANCIA_HORA"
              placeholder="Distância em Horas"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Distância em Metros:">
            <b-form-input
              type="number"
              v-model="emitente.DISTANCIA_KM"
              placeholder="Distância em Metros"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="E-Mail:">
            <b-form-input
              type="email"
              v-model="emitente.E_MAIL"
              placeholder="E-Mail"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Site:">
            <b-form-input
              type="text"
              v-model="emitente.WWW"
              placeholder="Site"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Classificação:" style="margin-bottom: 0px;">
            <b-form-radio v-model="emitente.CLASSIFICACAO" name="classificacao" value="0" style="margin-bottom: 8px;">
              <img src="media/icons/diamond.png" style="width: 20px;" /> {{ (campo1Classificacao) ? campo1Classificacao : 'Diamante' }}
            </b-form-radio>
            <b-form-radio v-model="emitente.CLASSIFICACAO" name="classificacao" value="1" style="margin-bottom: 8px;">
              <img src="media/icons/gold_medal.png" style="width: 20px;" /> {{ (campo2Classificacao) ? campo2Classificacao : 'Ouro' }}
            </b-form-radio>
            <b-form-radio v-model="emitente.CLASSIFICACAO" name="classificacao" value="2" style="margin-bottom: 8px;">
              <img src="media/icons/silver_medal.png" style="width: 20px;" /> {{ (campo3Classificacao) ? campo3Classificacao : 'Prata' }}
            </b-form-radio>
            <b-form-radio v-model="emitente.CLASSIFICACAO" name="classificacao" value="3" style="margin-bottom: 8px;">
              <img src="media/icons/bronze_medal.png" style="width: 20px;" /> {{ (campo4Classificacao) ? campo4Classificacao : 'Bronze' }}
            </b-form-radio>
            <b-form-radio v-model="emitente.CLASSIFICACAO" name="classificacao" value="4" style="margin-bottom: 8px;">
              <img src="media/icons/fire.png" style="width: 20px;" /> {{ (campo5Classificacao) ? campo5Classificacao : 'Em exceção' }}
            </b-form-radio>
            <b-form-radio v-model="emitente.CLASSIFICACAO" name="classificacao" value="">
              <img src="media/icons/empty.png" style="width: 20px;" /> Sem classificação
            </b-form-radio>
          </b-form-group>
        </div>
      </div>
    </b-collapse>
    <div class="separator separator-dashed my-5"></div>
    <EmitenteRegistros ref="registros" :registrosEmitente="registros" />
    <div class="separator separator-dashed my-5"></div>
    <h3 class="font-size-lg text-dark font-weight-bold mb-6 titulo-collapse" :class="{'titulo-collapse-fechado': !exibirMultasCreditos}" @click="exibirMultasCreditos = !exibirMultasCreditos">
      Multas / Créditos: <img class="image-collapse" src="media/icons/arrow-down.png" :class="{'image-collapse-rotate': exibirMultasCreditos}" />
    </h3>
    <b-collapse class="conteudo-collapse" :visible="exibirMultasCreditos">
      <div class="row">
        <div class="col-md-6">
          <b-form-group>
            <SearchBoxTipoMulta label="Tipo de Multa a pagar" ref="tipoMultaPagar" v-model="emitente.ID_TIPO_DE_MULTA_PAGAR" />
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group>
            <SearchBoxTipoMulta label="Tipo de Multa a receber" ref="tipoMultaReceber" v-model="emitente.ID_TIPO_DE_MULTA_RECEBER" />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group>
            <SearchBoxPlanoFinanceiro label="Plano Financeiro a pagar" ref="planoFinanceiroPagar" v-model="emitente.ID_PLANO_FINANCEIRO_PAGAR" />
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group>
            <SearchBoxPlanoFinanceiro label="Plano Financeiro a receber" ref="planoFinanceiroReceber" v-model="emitente.ID_PLANO_FINANCEIRO_RECEBER" />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Históricos Padrões para Inclusão de Acervos:" style="margin-bottom: 0;">
            <b-form-textarea
              v-model="emitente.TITULOS_ACERVOS_PADRAO"
              placeholder="Históricos Padrões para Inclusão de Acervos"
              rows="8"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Históricos Padrões para Inclusão de Títulos:" style="margin-bottom: 0;">
            <b-form-textarea
              v-model="emitente.TITULOS_HISTORICOS_PADRAO"
              placeholder="Históricos Padrões para Inclusão de Títulos"
              rows="8"
            ></b-form-textarea>
          </b-form-group>
        </div>
      </div>
    </b-collapse>
  </FormCadastro>
</template>

<style lang="scss">
  .tab-content.mt-3 {
    margin-top: 0px !important;
  }

  .tab-content.mt-3 .tab-pane {
    border: 1px solid #E4E6EF;
    border-bottom-left-radius: 0.42rem;
    border-bottom-right-radius: 0.42rem;
    border-top: 0px;
    padding-top: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }

  .titulo-collapse {
    border: 1px solid #E4E6EF;
    border-bottom: 0;
    border-top-left-radius: 0.42rem;
    border-top-right-radius: 0.42rem;
    cursor: pointer;
    padding: 10px;
    margin-bottom: 0 !important;
  }

  .titulo-collapse-fechado {
    border-bottom: 1px solid #E4E6EF !important;
    border-bottom-left-radius: 0.42rem;
    border-bottom-right-radius: 0.42rem;
  }

  .conteudo-collapse {
    border: 1px solid rgb(228, 230, 239);
    border-top: 0;
    border-bottom-left-radius: 0.42rem;
    border-bottom-right-radius: 0.42rem;
    padding: 10px;
  }

  .image-collapse {
    width: 14px;
    float: right;
  }

  .image-collapse-rotate {
    transform: rotate(180deg);
  }

  .swal2-textarea {
    height: 250px;
  }
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapActions } from "vuex";

import FormCadastro from "@/../../components-spirit/FormCadastro/FormCadastro.vue";

import InputCPF from "@/../../components-spirit/Inputs/InputCPF.vue";
import InputCNPJ from "@/../../components-spirit/Inputs/InputCNPJ.vue";
import InputCEP from "@/../../components-spirit/Inputs/InputCEP.vue";
import InputLogradouroTipo from "@/../../components-spirit/Inputs/InputLogradouroTipo.vue";
import InputEstado from "@/../../components-spirit/Inputs/InputEstado.vue";
import InputCidade from "@/../../components-spirit/Inputs/InputCidade.vue";

import SearchBoxCategoriaEmitente from "@/../../components-spirit/SearchBox/SearchBoxCategoriaEmitente.vue";
import SearchBoxProfissao from "@/../../components-spirit/SearchBox/SearchBoxProfissao.vue";
import SearchBoxTipoMulta from "@/../../components-spirit/SearchBox/SearchBoxTipoMulta.vue";
import SearchBoxPlanoFinanceiro from "@/../../components-spirit/SearchBox/SearchBoxPlanoFinanceiro.vue";

import EmitenteTelefones from "@/view/pages/cadastros/EmitenteTelefones.vue";
import EmitenteRegistros from "@/view/pages/cadastros/EmitenteRegistros.vue";

import Swal from "sweetalert2";
import moment from "moment";

export default {
  name: "Emitente",
  components: {
    FormCadastro,
    InputCPF,
    InputCNPJ,
    InputCEP,
    InputLogradouroTipo,
    InputEstado,
    InputCidade,
    SearchBoxCategoriaEmitente,
    SearchBoxProfissao,
    SearchBoxTipoMulta,
    SearchBoxPlanoFinanceiro,
    EmitenteTelefones,
    EmitenteRegistros
  },
  data() {
    return {
      emitenteVazio: {},
      emitente: {
        ID_EMITENTE: "",
        ID_EMITENTE_CATEGORIA: "",
        PESSOA: "F",
        CGC_CPF: "",
        DATA_NASCIMENTO: "",
        TRATAMENTO: "Sr.",
        RAZAO_SOCIAL: "",
        NOME_FANTASIA: "",
        NOME_RESUMIDO: "",
        SEXO: "",
        TIPO_ENDERECO: "R",
        CEP: "",
        LOGRADOURO_TIPO: "Rua",
        LOGRADOURO_NOME: "",
        LOGRADOURO_NUMERO: "",
        LOGRADOURO_COMPLEMENTO: "",
        BAIRRO: "",
        ESTADO: "",
        CIDADE: "",
        PAIS: "",
        LOCALIDADE: "",
        COD_IBGE: "",
        TIPO_END_COBR: "R",
        COBR_CEP: "",
        COBR_LOGRADOURO_TIPO: "Rua",
        COBR_LOGRADOURO: "",
        COBR_LOGRADOURO_NUMERO: "",
        COBR_LOGRADOURO_COMPLEMENTO: "",
        COBR_BAIRRO: "",
        COBR_CIDADE: "",
        COBR_ESTADO: "",
        USA_DDA: "0",
        OBSERVACAO: "",
        OBSERVACAO_ATENDIMENTO: "",
        NATURALIDADE: "",
        DATA_FORMATURA: "",
        CONSELHO_NUMERO: "",
        ID_PROFISSAO: "",
        CAMPO1: "",
        CAMPO2: "",
        CAMPO3: "",
        CAMPO4: "",
        CAMPO_COMBO_1: "",
        CAMPO_COMBO_2: "",
        CAMPO_COMBO_3: "",
        CAMPO_COMBO_4: "",
        DATA_ADMISSAO: "",
        REGISTRO: "",
        INSCRICAOESTADUAL_RG: "",
        DATA_EMISSAO_RG: "",
        ORGAO_EXPEDIDOR: "",
        DISTANCIA_HORA: "",
        DISTANCIA_KM: "",
        E_MAIL: "",
        WWW: "",
        CLASSIFICACAO: "",
        ID_TIPO_DE_MULTA_PAGAR: "",
        ID_TIPO_DE_MULTA_RECEBER: "",
        ID_PLANO_FINANCEIRO_PAGAR: "",
        ID_PLANO_FINANCEIRO_RECEBER: "",
        TITULOS_HISTORICOS_PADRAO: "",
        TITULOS_ACERVOS_PADRAO: "",
        DATA_INCLUSAO: "",
        USUARIO_INCLUSAO: "",
        DATA_ALTERACAO: "",
        USUARIO: "",
        CGC_CPF_STATUS_RECEITA: "",
        CGC_CPF_SITUACAO: "",
        CGC_CPF_SITUACAO_DATA: "",
        CGC_CPF_SITUACAO_USUARIO: "",
        OBSERVACAO_EMITENTE: ""
      },
      tratamentos: [
        "Sr.",
        "Sra.",
        "Dr.",
        "Dra.",
        "Prof.",
        "Exmo.",
        "Exma.",
        "Ilmo.",
        "Ilma.",
        "Mr.",
        "Mrs.",
        "Ms."
      ],
      sexos: [
        { value: "", text: "Selecione o sexo" },
        { value: "M", text: "Masculino" },
        { value: "F", text: "Feminino" },
        { value: "O", text: "Outros" }
      ],
      cidades: [],
      cidadesCobr: [],
      campo1Nome: "",
      campo2Nome: "",
      campo3Nome: "",
      campo4Nome: "",
      campoCombo1Nome: "",
      campoCombo2Nome: "",
      campoCombo3Nome: "",
      campoCombo4Nome: "",
      campoCombo1opcoes: [],
      campoCombo2opcoes: [],
      campoCombo3opcoes: [],
      campoCombo4opcoes: [],
      campo1Classificacao: "",
      campo2Classificacao: "",
      campo3Classificacao: "",
      campo4Classificacao: "",
      campo5Classificacao: "",
      telefones: [],
      registros: [],
      loading: false,
      exibirBotoes: true,
      exibirDadosPrincipais: true,
      exibirEnderecos: false,
      exibirInformacoesAdicionais: false,
      exibirCamposConfiguraveis: false,
      exibirRegistros: false,
      exibirMultasCreditos: false,
      botoesMenu: [
        {
          title: "Observações Reservadas",
          evento: "observacoesReservadas",
          exibir: true
        }
      ]
    };
  },
  async mounted() {
    Object.keys(this.emitente).forEach((item) => this.emitenteVazio[item] = this.emitente[item]);
    if ((this.$route.params.id) && (this.$route.params.id != '0')) {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: "Alterar emitente" }]);

      this.loading = true;

      let emitente = await this.getEmitente(this.$route.params.id);
      this.atribuirObj(emitente);

      this.loading = false;
    } else {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: "Incluir emitente" }]);

      if(this.$route.params.nome) {
        this.emitente.RAZAO_SOCIAL = this.$route.params.nome;
      }
    }

    this.buscaConfiguracoes();
  },
  methods: {
    ...mapActions(["getConfiguracaoMaster", "getEmitente", "updateEmitente"]),
    atribuirObj(emitente) {
      Object.keys(emitente.EMITENTE).forEach((item) => this.emitente[item] = emitente.EMITENTE[item]);

      this.$nextTick(() => {
        if(this.emitente.CGC_CPF) {
          if(this.emitente.PESSOA == 'F') {
            this.$refs.cpf.validar();
          } else {
            this.$refs.cnpj.validar();
          }       
        }

        if(this.emitente.CEP) {
          this.$refs.cep.validar();
        }

        if(this.emitente.COBR_CEP) {
          this.$refs.cobrcep.validar();
        }

        if(this.emitente.ID_EMITENTE_CATEGORIA) {
          this.$refs.categoriaEmitente.selecionar({
            ID: this.emitente.ID_EMITENTE_CATEGORIA,
            DESCRICAO: emitente.INFOS.CATEGORIA
          });
        }

        if(this.emitente.ID_PROFISSAO) {
          this.$refs.profissao.selecionar({
            ID: this.emitente.ID_PROFISSAO,
            DESCRICAO: emitente.INFOS.PROFISSAO
          });
        }

        if(this.emitente.ID_TIPO_DE_MULTA_PAGAR) {
          this.$refs.tipoMultaPagar.selecionar({
            ID: this.emitente.ID_TIPO_DE_MULTA_PAGAR,
            DESCRICAO: emitente.INFOS.TIPO_MULTA_PAGAR
          });
        }

        if(this.emitente.ID_TIPO_DE_MULTA_RECEBER) {
          this.$refs.tipoMultaReceber.selecionar({
            ID: this.emitente.ID_TIPO_DE_MULTA_RECEBER,
            DESCRICAO: emitente.INFOS.TIPO_MULTA_RECEBER
          });
        }

        if(this.emitente.ID_PLANO_FINANCEIRO_PAGAR) {
          this.$refs.planoFinanceiroPagar.selecionar({
            ID: this.emitente.ID_PLANO_FINANCEIRO_PAGAR,
            DESCRICAO: emitente.INFOS.PLANO_FINANCEIRO_PAGAR
          });
        }

        if(this.emitente.ID_PLANO_FINANCEIRO_RECEBER) {
          this.$refs.planoFinanceiroReceber.selecionar({
            ID: this.emitente.ID_PLANO_FINANCEIRO_RECEBER,
            DESCRICAO: emitente.INFOS.PLANO_FINANCEIRO_RECEBER
          });
        }

        this.registros = [];

        let nomes = [];
        if(this.emitente.ACESSOS_REMOTOS_NOME) {
          nomes = this.emitente.ACESSOS_REMOTOS_NOME.split(/\r?\n/);
        }

        let logins = [];
        if(this.emitente.ACESSOS_REMOTOS_LOGIN) {
          logins = this.emitente.ACESSOS_REMOTOS_LOGIN.split(/\r?\n/);
        }

        let senhas = [];
        if(this.emitente.ACESSOS_REMOTOS_SENHA) {
          senhas = this.emitente.ACESSOS_REMOTOS_SENHA.split(/\r?\n/);
        }

        let descricoes = [];
        if(this.emitente.ACESSOS_REMOTOS_DESC) {
          descricoes = this.emitente.ACESSOS_REMOTOS_DESC.split(/\r?\n/);
        }

        nomes.forEach((nome, index) => {
          if(typeof this.registros[index] === 'undefined') {
            if(nome) {
              this.registros[index] = {
                NOME: nome
              };
            }
          } else {
            this.registros[index].NOME = nome;
          }
        });

        logins.forEach((login, index) => {
          if(typeof this.registros[index] === 'undefined') {
            if(login) {
              this.registros[index] = {
                LOGIN: login
              };
            }
          } else {
            this.registros[index].LOGIN = login;
          }
        });

        senhas.forEach((senha, index) => {
          if(typeof this.registros[index] === 'undefined') {
            if(senha) {
              this.registros[index] = {
                SENHA: senha
              };
            }
          } else {
            this.registros[index].SENHA = senha;
          }
        });

        descricoes.forEach((descricao, index) => {
          if(typeof this.registros[index] === 'undefined') {
            if(descricao) {
              this.registros[index] = {
                DESCRICAO: descricao
              };
            }
          } else {
            this.registros[index].DESCRICAO = descricao;
          }
        });

        this.telefones = emitente.TELEFONES;
        this.$nextTick(() => {
          this.$refs.telefones.atribuirTelefones();
          this.$refs.registros.atribuirRegistros();
        });
      });
    },
    async buscaConfiguracoes() {
      let configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'CONTEUDO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CAMPO_CONFIGURADO_1',
        CONTEUDO: ''
      });

      if(configuracao.CONTEUDO) {
        this.campo1Nome = configuracao.CONTEUDO;
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'CONTEUDO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CAMPO_CONFIGURADO_2',
        CONTEUDO: ''
      });

      if(configuracao.CONTEUDO) {
        this.campo2Nome = configuracao.CONTEUDO;
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'CONTEUDO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CAMPO_CONFIGURADO_3',
        CONTEUDO: ''
      });

      if(configuracao.CONTEUDO) {
        this.campo3Nome = configuracao.CONTEUDO;
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'CONTEUDO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CAMPO_CONFIGURADO_4',
        CONTEUDO: ''
      });

      if(configuracao.CONTEUDO) {
        this.campo4Nome = configuracao.CONTEUDO;
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'CONTEUDO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CAMPO_CONFIGURADO_COMBO_NOME_1',
        CONTEUDO: ''
      });

      if(configuracao.CONTEUDO) {
        this.campoCombo1Nome = configuracao.CONTEUDO;
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'CONTEUDO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CAMPO_CONFIGURADO_COMBO_NOME_2',
        CONTEUDO: ''
      });

      if(configuracao.CONTEUDO) {
        this.campoCombo2Nome = configuracao.CONTEUDO;
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'CONTEUDO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CAMPO_CONFIGURADO_COMBO_NOME_3',
        CONTEUDO: ''
      });

      if(configuracao.CONTEUDO) {
        this.campoCombo3Nome = configuracao.CONTEUDO;
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'CONTEUDO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CAMPO_CONFIGURADO_COMBO_NOME_4',
        CONTEUDO: ''
      });

      if(configuracao.CONTEUDO) {
        this.campoCombo4Nome = configuracao.CONTEUDO;
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'TEXTO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CAMPO_CONFIGURADO_COMBO_1',
        CONTEUDO: ''
      });

      if(configuracao.TEXTO) {
        this.campoCombo1opcoes = configuracao.TEXTO.split(/\r?\n/).filter((item) => { return (item) ? true : false; });
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'TEXTO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CAMPO_CONFIGURADO_COMBO_2',
        CONTEUDO: ''
      });

      if(configuracao.TEXTO) {
        this.campoCombo2opcoes = configuracao.TEXTO.split(/\r?\n/).filter((item) => { return (item) ? true : false; });
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'TEXTO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CAMPO_CONFIGURADO_COMBO_3',
        CONTEUDO: ''
      });

      if(configuracao.TEXTO) {
        this.campoCombo3opcoes = configuracao.TEXTO.split(/\r?\n/).filter((item) => { return (item) ? true : false; });
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'TEXTO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CAMPO_CONFIGURADO_COMBO_4',
        CONTEUDO: ''
      });

      if(configuracao.TEXTO) {
        this.campoCombo4opcoes = configuracao.TEXTO.split(/\r?\n/).filter((item) => { return (item) ? true : false; });
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'CONTEUDO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CLASSIFICACAO_1',
        CONTEUDO: ''
      });

      if(configuracao.CONTEUDO) {
        this.campo1Classificacao = configuracao.CONTEUDO;
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'CONTEUDO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CLASSIFICACAO_2',
        CONTEUDO: ''
      });

      if(configuracao.CONTEUDO) {
        this.campo2Classificacao = configuracao.CONTEUDO;
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'CONTEUDO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CLASSIFICACAO_3',
        CONTEUDO: ''
      });

      if(configuracao.CONTEUDO) {
        this.campo3Classificacao = configuracao.CONTEUDO;
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'CONTEUDO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CLASSIFICACAO_4',
        CONTEUDO: ''
      });

      if(configuracao.CONTEUDO) {
        this.campo4Classificacao = configuracao.CONTEUDO;
      }

      configuracao = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: 'CONTEUDO',
        NIVEL: '1',
        OPERACAO: 'C',
        USUARIO: 'GERAL',
        SISTEMA: 'GERAL',
        MODULO: 'EMITENTE',
        CAMPO: 'CLASSIFICACAO_5',
        CONTEUDO: ''
      });

      if(configuracao.CONTEUDO) {
        this.campo5Classificacao = configuracao.CONTEUDO;
      }
    },
    buscaCEP(cep) {
      this.cidades = [];

      this.emitente.LOGRADOURO_TIPO = cep.logradouro.split(" ")[0];
      this.emitente.LOGRADOURO_NOME = cep.logradouro.substr(
        cep.logradouro.indexOf(" ") + 1
      );
      this.emitente.BAIRRO = cep.bairro;
      this.emitente.CIDADE = cep.localidade;
      this.emitente.ESTADO = cep.uf;
      this.emitente.LOCALIDADE = cep.localidade;
      this.emitente.COD_IBGE = cep.ibge;
    },
    buscaCEPCobr(cep) {
      this.cidades = [];

      this.emitente.COBR_LOGRADOURO_TIPO = cep.logradouro.split(" ")[0];
      this.emitente.COBR_LOGRADOURO = cep.logradouro.substr(
        cep.logradouro.indexOf(" ") + 1
      );
      this.emitente.COBR_BAIRRO = cep.bairro;
      this.emitente.COBR_CIDADE = cep.localidade;
      this.emitente.COBR_ESTADO = cep.uf;
    },
    buscaCidades(cidades) {
      let vm = this;
      this.cidades = [];
      this.emitente.CIDADE = "";

      if (cidades.length) {
        this.cidades.push({ value: "", text: "Selecione a cidade", ibge: "" });

        cidades.forEach(function(cidade) {
          vm.cidades.push({
            value: cidade.nome,
            text: cidade.nome,
            ibge: cidade.id
          });
        });
      }
    },
    buscaCidadesCobr(cidades) {
      let vm = this;
      this.cidadesCobr = [];
      this.emitente.CIDADE = "";

      if (cidades.length) {
        this.cidadesCobr.push({ value: "", text: "Selecione a cidade", ibge: "" });

        cidades.forEach(function(cidade) {
          vm.cidadesCobr.push({
            value: cidade.nome,
            text: cidade.nome,
            ibge: cidade.id
          });
        });
      }
    },
    selecionouCidade() {
      if (this.cidades.length) {
        let vm = this;
        this.emitente.LOCALIDADE = this.emitente.CIDADE;

        this.cidades.forEach(function(cidade) {
          if (cidade.value == vm.emitente.CIDADE) {
            vm.emitente.COD_IBGE = cidade.ibge.substring(0, cidade.ibge.length - 2);
          }
        });
      }
    },
    hasHistory () {
      return window.history.length > 2;
    },
    voltar() {
      if(this.hasHistory()) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    },
    async clickMenu(opcao) {
      if(opcao == "observacoesReservadas") {
        let valor = "";
        
        let swalResponse = await Swal.fire({
          title: 'Observações Reservadas',
          input: 'textarea',
          inputValue: this.emitente.OBSERVACAO_EMITENTE,
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Salvar',
          preConfirm: (observacao) => {
            valor = observacao;
          }
        });
        
        if(swalResponse.isConfirmed) {
          this.emitente.OBSERVACAO_EMITENTE = valor;
          this.salvar(1);
        }
      }
    },
    limparForm() {
      Object.keys(this.emitenteVazio).forEach((item) => this.emitente[item] = this.emitenteVazio[item]);
    },
    validarObjTitulo(obj) {
      let retorno = "";

      if (!obj.RAZAO_SOCIAL) {
        retorno = "O nome ou razão social é um campo obrigatório.";
      } else if((obj.PESSOA == 'F') && (obj.CGC_CPF) && (!this.$refs.cpf.validar())) {
        retorno = "O CPF informado não é válido.";
      } else if((obj.PESSOA == 'J') && (obj.CGC_CPF) && (!this.$refs.cnpj.validar())) {
        retorno = "O CNPJ informado não é válido.";
      }

      return retorno;
    },
    async salvar(tipo) {
      let obj = {};

      Object.keys(this.emitenteVazio).forEach((item) => obj[item] = this.emitente[item]);

      obj.TELEFONES = this.$refs.telefones.retornar();
      obj.REGISTROS = this.$refs.registros.retornar();

      let retorno = this.validarObjTitulo(obj);

      if (retorno) {
        Swal.fire({
          title: "Aviso",
          text: retorno,
          icon: "warning",
          timer: 3000,
          showConfirmButton: false
        });
      } else {
        this.loading = true;
        let retornoObj = await this.updateEmitente(obj);
        if (retornoObj.USUARIO_INCLUSAO) {
          this.emitente.USUARIO_INCLUSAO = retornoObj.USUARIO_INCLUSAO;
        }
        if (retornoObj.USUARIO) {
          this.emitente.USUARIO = retornoObj.USUARIO;
        }
        if (retornoObj.DATA_INCLUSAO) {
          this.emitente.DATA_INCLUSAO = retornoObj.DATA_INCLUSAO;
        }
        if (retornoObj.DATA_ALTERACAO) {
          this.emitente.DATA_ALTERACAO = retornoObj.DATA_ALTERACAO;
        }
        this.loading = false;

        Swal.fire({
          title: "Aviso",
          text: "Emitente salvo com sucesso.",
          icon: "success",
          timer: 3000,
          showConfirmButton: false
        });

        if (tipo === 0) {
          this.voltar();
        } else if (tipo === 1) {
          this.$router.push({ path: "/cadastros/emitente/" + retornoObj.ID_EMITENTE });
        } else if (tipo === 2) {
          this.limparForm();
          this.$router.push({ path: "/cadastros/emitente" });
        }
      }
    },
    validacaoReceitaCNPJ(dados) {
      if(dados.status == "OK") {
        this.emitente.RAZAO_SOCIAL = dados.razaoSocial;

        this.emitente.CGC_CPF_STATUS_RECEITA = "1";
        this.emitente.CGC_CPF_SITUACAO = dados.situacao;
        this.emitente.CGC_CPF_SITUACAO_DATA = moment().format("YYYY-MM-DD HH:mm:ss");

        if(dados.dataFundacao) {
          this.emitente.DATA_NASCIMENTO = moment(dados.dataFundacao, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
        
        if(dados.nomeFantasia) {
          this.emitente.NOME_FANTASIA = dados.nomeFantasia;
        }

        this.emitente.OBSERVACAO += "\n";

        if(dados.cnaePrincipal) {
          this.emitente.OBSERVACAO += "CNAE Principal Receita: " + dados.cnaePrincipal + "\n";
          this.emitente.OBSERVACAO += "\n";
        }

        if(dados.cnaeSecundarios.length) {
          this.emitente.OBSERVACAO += "CNAE Secundário Receita: \n";
          dados.cnaeSecundarios.forEach((cnae) => (this.emitente.OBSERVACAO += cnae + "\n"));
          this.emitente.OBSERVACAO += "\n";
        }

        if(dados.telefone) {
          this.emitente.OBSERVACAO += "Telefone Registrado Receita: " + dados.telefone + " \n";
        }

        if(dados.email) {
          this.emitente.E_MAIL = dados.email;
        }

        if(dados.logradouro) {
          this.emitente.LOGRADOURO_TIPO = dados.logradouro.split(' ')[0];
          this.emitente.LOGRADOURO_NOME = dados.logradouro.split(' ').slice(1).join(' ');
        }

        if(dados.logradouroNumero) {
          this.emitente.LOGRADOURO_NUMERO = dados.logradouroNumero;
        }

        if(dados.logradouroComplemento) {
          this.emitente.LOGRADOURO_COMPLEMENTO = dados.logradouroComplemento;
        }

        if(dados.cep) {
          this.emitente.CEP = dados.cep.replace(/[^\d]+/g, "");
        }

        if(dados.bairro) {
          this.emitente.BAIRRO = dados.bairro;
        }

        if(dados.cidade) {
          this.emitente.CIDADE = dados.cidade;
        }

        if(dados.uf) {
          this.emitente.ESTADO = dados.uf;
        }
      }
    },
    validacaoReceitaCPF(dados) {
      if(dados.status == "OK") {
        this.emitente.RAZAO_SOCIAL = dados.nome;

        this.emitente.CGC_CPF_STATUS_RECEITA = "1";
        this.emitente.CGC_CPF_SITUACAO = dados.situacao;
        this.emitente.CGC_CPF_SITUACAO_DATA = moment().format("YYYY-MM-DD HH:mm:ss");

        if(dados.dataNascimento) {
          this.emitente.DATA_NASCIMENTO = moment(dados.dataNascimento, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    preencheFantasiaResumido() {
      if(this.emitente.RAZAO_SOCIAL) {
        if(!this.emitente.NOME_FANTASIA) {
          this.emitente.NOME_FANTASIA = this.emitente.RAZAO_SOCIAL;
        }
        
        if(!this.emitente.NOME_RESUMIDO) {
          this.emitente.NOME_RESUMIDO = this.emitente.RAZAO_SOCIAL;
        }
      }
    }
  }
};
</script>
